import React from "react";
import { connect } from "react-redux";

import { getAvailableProducts } from "state/app/selectors";
import { isAppserverOnline, isProductAvailable } from "lib/validate";

import TeachersHomeSection from "components/app/home/sections/teachers/TeachersHomeSection";
import SchoolMoneyHomeSection from "components/app/home/sections/school_money/SchoolMoneyHomeSection";

/**
 * This component delegates to any of the sections in the
 *   'sections' subdirectory, based on the available products.
 */
class AvailableProductsHomeSections extends React.Component {

  render() {
    const { availableProducts } = this.props;
    const sections = [];
    if (availableProducts.includes("teachers") && isProductAvailable("teachers") && isAppserverOnline()) {
      sections.push(<TeachersHomeSection key="teachers" />);
    }
    if (availableProducts.includes("school_money") && isProductAvailable("school_money") && isAppserverOnline()) {
      sections.push(<SchoolMoneyHomeSection key="school_money" />);
    }
    return sections;
  }

}

export default connect(
  state => ({
    availableProducts: getAvailableProducts(state)
  })
)(AvailableProductsHomeSections)



// WEBPACK FOOTER //
// ./src/components/app/home/AvailableProductsHomeSections.js